require("!!/Users/maxBook/Sites/haendlerfromular/backend/bookstore/node_modules/script-loader/addScript.js")(require("!!/Users/maxBook/Sites/haendlerfromular/backend/bookstore/node_modules/raw-loader/index.js!/Users/maxBook/Sites/haendlerfromular/backend/bookstore/node_modules/mutationobserver-shim/dist/mutationobserver.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/mutationobserver-shim/dist/mutationobserver.min.js
// module id = 264
// module chunks = 3